import { SET_INPUTS_IS_OPEN } from './constants';

const defaultState = {
    isOpen: true,
};

const inputsUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_INPUTS_IS_OPEN:
            return { ...state, isOpen: action.isOpen };

        default:
            return state;
    }
};

export default inputsUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/reducer.js